export default __webpack_public_path__ + "img/024bdda05b6b1e0abbf5e4baf6e1cbd4.png";